export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkPrivati: "nav-link-privati",
  linkAziende: "nav-link-aziende",
  linkConfiguratore: "nav-link-configuratore",
  linkGuide: "nav-link-guide",
  linkAnalisi: "nav-link-analisi",
  ctaContattaci: "nav-cta-contatti",
  mobileToggle: "nav-mobile-toggle",
};

export const LANDING = {
  hero: "landing-hero",
  ctaPrivati: "hero-cta-privati",
  ctaAziende: "hero-cta-aziende",
  ctaConfigura: "hero-cta-configura",
  ctaAnalisi: "hero-cta-analisi",
  scrollDown: "hero-scroll-down",
  privatiCard: "section-privati-card",
  aziendeCard: "section-aziende-card",
  guidePrivati: "guida-privati-download",
  guideAziende: "guida-aziende-download",
  emailContatto: "footer-email-link",
  benefit: (i) => `benefit-item-${i}`,
};

export const ANALISI = {
  page: "analisi-preventivo-page",
  hero: "analisi-preventivo-hero",
  form: "analisi-preventivo-form",
  tipoPrivato: "analisi-tipo-privato",
  tipoAzienda: "analisi-tipo-azienda",
  nome: "analisi-nome",
  cognome: "analisi-cognome",
  ragioneSociale: "analisi-ragione-sociale",
  email: "analisi-email",
  telefono: "analisi-telefono",
  citta: "analisi-citta",
  provincia: "analisi-provincia",
  messaggio: "analisi-messaggio",
  consensoPrivacy: "analisi-consenso-privacy",
  consensoMarketing: "analisi-consenso-marketing",
  consensoPartner: "analisi-consenso-partner",
  submit: "analisi-submit",
  success: "analisi-success",
};

export const CONFIG = {
  root: "configuratore-root",
  tabPrivato: "config-tab-privato",
  tabAzienda: "config-tab-azienda",
  addressInput: "config-address-input",
  addressSearchBtn: "config-address-search",
  superficieSlider: "config-superficie-slider",
  superficieInput: "config-superficie-input",
  consumiInput: "config-consumi-input",
  orientamentoSelect: "config-orientamento",
  inclinazioneSlider: "config-inclinazione",
  regioneSelect: "config-regione",
  batteriaToggle: "config-batteria-toggle",
  batteriaKwh: "config-batteria-kwh",
  wallboxToggle: "config-wallbox-toggle",
  wallboxVeicoli: "config-wallbox-veicoli",
  wallboxKm: "config-wallbox-km",
  wallboxPotenza: "config-wallbox-potenza",
  drawStart: "config-draw-start",
  drawCommit: "config-draw-commit",
  drawCancel: "config-draw-cancel",
  drawClear: "config-draw-clear",
  pannelliSlider: "config-pannelli-slider",
  pannelliReset: "config-pannelli-reset",
  overLimitBanner: "config-over-limit-banner",
  warrantiesBox: "config-warranties-box",
  calcolaBtn: "config-calcola-btn",
  map: "config-map",
  view3d: "config-view-3d",
  view3dRotate: "config-view-3d-rotate",
  resultPanels: "result-pannelli",
  resultKwp: "result-kwp",
  resultProduzione: "result-produzione",
  resultRisparmio: "result-risparmio",
  resultTaglio: "result-taglio",
  resultPayback: "result-payback",
  resultCO2: "result-co2",
  resultInvestimento: "result-investimento",
  chartAutoconsumo: "chart-autoconsumo",
  leadOpenBtn: "lead-open-btn",
  leadForm: "lead-form",
  leadNome: "lead-nome",
  leadCognome: "lead-cognome",
  leadRagioneSociale: "lead-ragione-sociale",
  leadEmail: "lead-email",
  leadTelefono: "lead-telefono",
  leadCitta: "lead-citta",
  leadProvincia: "lead-provincia",
  leadMessaggio: "lead-messaggio",
  leadPrivacy: "lead-consenso-privacy",
  leadMarketing: "lead-consenso-marketing",
  leadSubmit: "lead-submit-btn",
};

export const COOKIE = {
  banner: "cookie-banner",
  accept: "cookie-accept-btn",
  reject: "cookie-reject-btn",
};

export const CHAT = {
  toggle: "chat-toggle",
  panel: "chat-panel",
  input: "chat-input",
  send: "chat-send",
  close: "chat-close",
  messages: "chat-messages",
};

export const ADMIN = {
  loginEmail: "admin-login-email",
  loginPassword: "admin-login-password",
  loginSubmit: "admin-login-submit",
  logout: "admin-logout",
  tabSettings: "admin-tab-settings",
  tabLeads: "admin-tab-leads",
  tabProjects: "admin-tab-projects",
  tabCases: "admin-tab-cases",
  saveSettings: "admin-save-settings",
  settingsInput: (k) => `admin-settings-${k}`,
  leadRow: (id) => `admin-lead-${id}`,
  newProject: "admin-new-project",
  newCase: "admin-new-case",
  projectRow: (id) => `admin-project-${id}`,
  caseRow: (id) => `admin-case-${id}`,
  saveEntity: "admin-save-entity",
  deleteEntity: (id) => `admin-delete-${id}`,
};

export const NARRATIVE = {
  privatiSection: "narrative-privati",
  aziendeSection: "narrative-aziende",
  incentivi: "narrative-incentivi",
  casiStudio: "sezione-casi-studio",
  projectSlider: "impianti-realizzati-slider",
  projectItem: (id) => `progetto-${id}`,
  caseItem: (id) => `caso-studio-${id}`,
  sliderPrev: "slider-prev",
  sliderNext: "slider-next",
};
